import React, { FunctionComponent } from "react";
import { confirm, Stack, Text } from "@bps/fluent-ui";
import { ApiCallButton } from "@components/buttons/ApiCallButton";
import { useSIATenantLicenceCheckQuery } from "@libs/api/gateways/sia/sia-ops-gateway.hooks";
import { useFeedbackContext } from "../../../../../../libs/stores/feedback-context/feedback-context";
import { useUpdateTenant } from "@libs/api/gateways/plt/plt-gateway.hooks";
import { Tenant, TenantDto } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { toTenantDto } from "@libs/api/gateways/plt/plt-gateway.utils";

interface SelfAssertedCrmDetailsProps {
  tenant: Tenant;
}

export const SelfAssertedCrmDetails: FunctionComponent<SelfAssertedCrmDetailsProps> = ({
  tenant
}) => {
  const { selfAssertedCrmId, crmId, id: tenantId } = tenant;
  const { error, success } = useFeedbackContext();

  const {
    mutateAsync: checkTenantLicences,
    isLoading: checkTenantLicencesLoading
  } = useSIATenantLicenceCheckQuery();

  const {
    mutateAsync: updateTenant,
    isLoading: updateTenantLoading
  } = useUpdateTenant();

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
      <Text>{selfAssertedCrmId}</Text>
      {!!selfAssertedCrmId && (
        <ApiCallButton
          error={undefined}
          isLoading={checkTenantLicencesLoading || updateTenantLoading}
          onClick={async () => {
            try {
              const res = await checkTenantLicences({
                tenantId,
                siteId: selfAssertedCrmId
              });
              if (res.success) {
                success(res.message ?? "Licence checked.");
              } else {
                error(res.message);
                return;
              }

              if (!crmId) {
                const isConfirmed = await confirm({
                  dialogContentProps: {
                    children: "Do you want to assign crmId?"
                  }
                });

                if (isConfirmed) {
                  const payload: TenantDto = {
                    ...toTenantDto(tenant),
                    crmId: selfAssertedCrmId
                  };
                  await updateTenant(payload);
                }
              }
            } catch (e) {
              error(e?.message);
            }
          }}
        >
          Check licence
        </ApiCallButton>
      )}
    </Stack>
  );
};
